var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    fillOpacity: 0.75,
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161729",
    fillRule: "evenodd",
    d: "m12.751 10.097 8.844 5.21c.4.235.525.737.279 1.12a.8.8 0 0 1-.279.266l-8.844 5.21a.7.7 0 0 1-.936-.213.63.63 0 0 1-.1-.341V10.65c0-.36.304-.651.68-.651.126 0 .25.034.356.097",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };